import get from 'lodash/get'
import DataProcessor from '@lib/processors/data-processor'
import api from '~/api'

export default class FloatElasticAdapter extends DataProcessor {
  constructor(params) {
    super(params)

    this.path = params.path
    /*
     * dataQuery is created in DataProcessor super
     */

    this.init()
  }

  async sendRequest(dataQuery) {
    const [, response] = await api.post(`${this.path}`, {
      from: dataQuery.pageSize * (dataQuery.page - 1),
      size: dataQuery.pageSize,
      sort: dataQuery.sort,
      query: dataQuery.query,
    })

    const data = get(response, 'hits.hits', []).map(i => i._source)
    const total = get(response, 'hits.total', 0)

    return { data, total }
  }
}
